import * as React from "react";
const SvgFilter = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V6.686l3.52 3.52 3.517 3.517v4.252c0 2.826.004 4.25.01 4.248l3.092-1.852 3.08-1.848.002-2.4v-2.4l3.517-3.518 3.52-3.52V1.872H12ZM3.38 3.38H20.62v2.683l-3.514 3.514-3.513 3.514v4.578l-1.586.951c-.872.523-1.59.951-1.594.953-.005.002-.008-1.39-.008-3.24V13.09L6.893 9.576 3.379 6.062V4.721Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgFilter;
